import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../../blocks/message/MessageContext";
import { Spinner } from "@fluentui/react-components";
import { candidateFormFields } from "./CandidateFormFields";
import { ENTITY_CANDIDATE } from "../../../utils/Constants";
import Ows from "../../../utils/OwsHandler";
import Form from "../../form/Form";

const CandidateForm = () => {
  const navigate = useNavigate();
  const { showMessage } = useMessage();
  const [loading, setLoading] = useState(false);
  const [statusList, setStatusList] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const data = await Ows.handleRequest("Otys.Services.CandidateService.getStatusListWithRanks");

        if (data.error) {
          throw new Error(data.error.message);
        }

        setStatusList(data.response || {});
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  const createCandidate = async () => {
    try {
      const data = await Ows.handleRequest("Otys.Services.CandidateService.add", [
        {
          Person: {
            firstName: "New candidate",
          },
        },
      ]);

      if (data.error) {
        throw new Error(data.error.message);
      }

      return data.response;
    } catch (error) {
      console.error(error);
    }
  };

  const updateCandidate = async (uid, formData) => {
    setLoading(true);
    try {
      const data = await Ows.handleRequest("Otys.Services.CandidateService.update", [
        uid,
        {
          Person: {
            firstName: formData.firstName,
            infix: formData.infix,
            lastName: formData.lastName,
            emailPrimary: formData.email,
            PhoneNumbers: {
              1: {
                phoneNumber: formData.phone,
              },
            },
          },
          statusId: formData.status,
        },
      ]);

      if (data.error) {
        throw new Error(data.error.message);
      }

      return data.response;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    const uid = await createCandidate();

    if (!uid) {
      showMessage("error", "Failed to create candidate.");
      return;
    }

    const candidate = await updateCandidate(uid, formData);

    if (!candidate) {
      showMessage("error", "Failed to create candidate.");
    } else {
      showMessage("success", "Candidate created successfully.");
      navigate(`/${ENTITY_CANDIDATE.toLowerCase()}/${uid}`, { state: { skipPageHeader: true } });
    }
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <Form title="Create new candidate" fields={candidateFormFields(statusList)} onSubmit={handleSubmit} />
      )}
    </>
  );
};

export default CandidateForm;
